import {OptionAttribute} from "../../../../data";
import {stateSelectedAccessories, stateSelectedComplectations} from "../../../../data/atoms";
import {useRecoilValue} from "recoil";


export const useOptionAttributeDisabled = (optionAttribute: OptionAttribute) => {
    const selectedComplectations = useRecoilValue(stateSelectedComplectations);
    const selectedAccessories = useRecoilValue(stateSelectedAccessories);

    const selected = {
        ...selectedComplectations,
        ...selectedAccessories,
    };

    const optionDependencies = optionAttribute.dependencies;

    if (optionDependencies) {
        const dependencyKeys = optionDependencies && Object.keys(optionDependencies);

        const isVisible = dependencyKeys.every((key) => {
            const value = selected[key]?.id || null;
            const hasKey = selected.hasOwnProperty(key);
            const hasValue = value && optionDependencies[key].includes(value);

            return hasKey && hasValue;
        });

        if (!isVisible) {
            return true;
        }
    }

    return false;
}

export const useOptionAttributeSelected = (uid: string, optionAttribute: OptionAttribute) => {
    const selectedComplectations = useRecoilValue(stateSelectedComplectations);
    const selectedAccessories = useRecoilValue(stateSelectedAccessories);

    const selected = {
        ...selectedComplectations,
        ...selectedAccessories
    };

    const withoutSlots = (selected.hasOwnProperty(uid) && selected[uid]?.id === optionAttribute.id);

    const withSlots = Object.keys(selected).some((selectedUid) =>
        selectedUid.startsWith(uid) && selected[selectedUid]?.id === optionAttribute.id
    );

    return withoutSlots || withSlots;
}
